import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Part } from "@/features/sub-families/types";
import type { Nullable, ResponsiveImage } from "@/types";

type State = {
    allParts: Nullable<ResponsiveImage>;
    items: Part[];
    allowAllParts: boolean;
};

const initialState: State = {
    allParts: null,
    items: [],
    allowAllParts: false,
};

const slice = createSlice({
    name: "parts",
    initialState,
    reducers: {
        partsSetAction: (state: State, action: PayloadAction<Part[]>) => {
            state.items = action.payload;
        },
        partsSetAllPartsAction: (state: State, action: PayloadAction<Nullable<ResponsiveImage>>) => {
            state.allParts = action.payload;
        },
        partsSetAllowAllPartsAction: (state: State, action: PayloadAction<boolean>) => {
            state.allowAllParts = action.payload;
        },
    },
});

export const { partsSetAction, partsSetAllPartsAction, partsSetAllowAllPartsAction } = slice.actions;

export default slice.reducer;
